


























import {useGetters} from "vuex-composition-helpers";
import LinkDirective from '@/shared/directives/link-directive';
import {defineComponent} from "@vue/composition-api";

export default defineComponent({
  name: "TaskComponent",
  props: {
    task: {
      type: Object,
      required: true,
    }
  },
  directives: {
    LinkDirective
  },
  setup() {
    const {config} = useGetters(['config'])

    return {
      config
    }
  }
})
